import axios from 'axios'
import urls from '../../util/urls'

const state = {
  listaDeContasReceberAtrasadas: []
}

const mutations = {
  atualizarListaDeContasReceberAtrasadas(state, payload) {
    state.listaDeContasReceberAtrasadas = payload;
  },

  limparContasReceber(state) {
    state.listaDeContasReceberAtrasadas = [];
  }
}

const actions = {
  recuperarContasReceberAtrasadas(context) {
    return axios.get(urls.DASHBOARD_RECUPERAR_CONTAS_RECEBER_ATRASADAS)
    .then((response) => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarContasReceberAtrasadas');
            }
          }).catch(error => {
            throw error;
          });
        default:
          return context.commit('atualizarListaDeContasReceberAtrasadas', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}